module.exports = __webpack_public_path__ + "static/media/ParentsGuidePageKK.c00a1b2d.pdf";